export function getDurationValue(duration: string | number | undefined): number | undefined {
  if (typeof duration === 'string') {
    if (duration.includes('m')) {
      const parsed = parseInt(duration);
      return isNaN(parsed) ? undefined : parsed * 60;
    } else {
      const parsed = Number(duration);
      return isNaN(parsed) ? undefined : parsed * 60;
    }
  } else if (typeof duration === 'number') {
    return duration * 60;
  }

  return undefined;
}
